import {
  fetchBasedCall,
  type IHttpCall,
  type IHttpRequest,
  type IHttpResponse,
} from '@hc-frontend/core-utils-net';

import {
  DecryptParamsRequest,
  DecryptParamsResponse,
} from './decrypt-params.types';

type DecryptParamsOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export async function decryptParamsService(
  baseUrl: string,
  body: DecryptParamsRequest,
  options?: DecryptParamsOptions,
): Promise<IHttpResponse<DecryptParamsResponse>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<DecryptParamsRequest> = {
    url: `${baseUrl}/external/api/v1/cipher/decrypt/`,
    method: 'POST',
    headers,
    body,
    schemas: {
      request: DecryptParamsRequest,
      response: DecryptParamsResponse,
    },
    ...restOptions,
  };

  return httpCall(request);
}
